import React from "react";

export default function Logo() {
  return (
    <svg
      width="600"
      height="500"
      viewBox="0 0 600 500"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M588.461 241.054H449.999C445.281 241.054 441.039 242.619 439.286 244.832L406.809 285.914L380.472 228.283C379.259 225.625 374.598 223.771 369.163 223.778C363.766 223.794 359.111 225.705 357.957 228.369L293.285 377.75L253.8 153.317C253.333 150.67 249.385 148.518 244.2 148.083C239.006 147.651 233.898 148.925 231.762 151.353L142.501 252.713H11.5383C5.16679 252.713 0 255.324 0 258.543C0 261.763 5.16679 264.373 11.5383 264.373H150C154.559 264.373 158.691 263.131 160.544 261.025L234.759 176.713L276.967 416.665C277.471 419.533 282.044 421.799 287.73 421.982C287.978 421.989 288.223 422 288.468 422C293.853 422 298.569 420.11 299.733 417.42L369.531 256.205L392.603 306.72C393.736 309.203 397.932 311.026 402.96 311.222C408.014 311.419 412.686 309.826 414.559 307.46L457.812 252.713H588.462C594.834 252.713 600 250.102 600 246.883C599.999 243.664 594.832 241.054 588.461 241.054Z"
        fill="#1DB954"
      />
      <circle cx="300" cy="250" r="240" stroke="#1DB954" strokeWidth="20" />
    </svg>
  );
}
